import { useState } from "react";
import { Download } from "lucide-react";
import { toast } from "sonner";
import { downloadApiFile } from "@/lib/api";
import { Button } from "@/components/ui/button";

export default function AnalysisExportButton({ meetingId, kind }) {
  const [loading, setLoading] = useState(false);
  const pdf = kind === "pdf";
  const download = async () => {
    setLoading(true);
    try {
      await downloadApiFile(`/meetings/${meetingId}/${pdf ? "summary-pdf" : "action-items-xlsx"}`, `${pdf ? "ringkasan" : "action-items"}-${meetingId}.${pdf ? "pdf" : "xlsx"}`);
    } catch { toast.error("Gagal mengunduh hasil analisis"); }
    finally { setLoading(false); }
  };
  return <Button type="button" variant="outline" size="sm" disabled={loading} onClick={download} className="rounded-none" data-testid={pdf ? "download-summary-pdf-btn" : "download-action-items-xlsx-btn"}>
    <Download size={14} className="mr-2" />{loading ? "Menyiapkan..." : pdf ? "Unduh PDF" : "Unduh Excel"}
  </Button>;
}
